import React from 'react';

const CmsPageShimmer = () => {
    return (
        <>
            <section className='ptb-60'>
                <div className='container'>
                    {Array.from({ length: 22 }, (_, index) => (
                        <div className='shimmer-para-line' key={index} />
                    ))}
                </div>
            </section>
        </>
    )
}

export default CmsPageShimmer;